import { type FC, useMemo } from 'react'
import { useCustomerLegalDocumentPartners } from '@egw/api'
import { useTranslation } from '@egw/i18n'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { WEALTH_ROUTES } from '@egw/constants'
import { ListLink } from '../list-link/list-link'

export interface DocumentCenterDocument {
  name: string
  rank: number | null
  url: string
}

export const Legal: FC = () => {
  const { t } = useTranslation('features-documents')
  const { data, isLoading } = useCustomerLegalDocumentPartners()
  const legalPartners = useMemo(
    () =>
      data?.partners.map((partnerEnum) => ({
        partnerEnum,
        name: t(`partners.${partnerEnum}`),
        id: partnerEnum,
        url: `${WEALTH_ROUTES.DOCUMENTS_LEGAL_PARTNER.path}?partner=${partnerEnum}`,
        rank: null,
      })),
    [data, t],
  )

  return (
    <>
      <h2 className="mb-4 mt-10 text-2xl font-semibold">{t('legal.title')}</h2>
      {isLoading ? (
        <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
          <Skeleton count={5} height="50px" />
        </SkeletonTheme>
      ) : null}

      {!isLoading && (
        <>
          {legalPartners?.map((item, index, array) => (
            <ListLink key={item.id} to={item.url} title={item.name} isLast={index === array.length - 1} />
          ))}
          {!legalPartners?.length && <div className="bg-bglight text-body px-3 py-3.5">{t('legal.no_documents')}</div>}
        </>
      )}
    </>
  )
}
